import React from "react";

function MenuContainer({ icon }) {
  return <div className="iconContainer">{icon}</div>;
}

export default MenuContainer;
